import { cn } from "@/lib/utils";

interface NarrativeCardProps {
  children: React.ReactNode;
  className?: string;
}

export function NarrativeCard({ children, className }: NarrativeCardProps) {
  return (
    <div
      className={cn(
        "flex flex-col gap-3 rounded-xl border border-border bg-card p-5",
        className
      )}
    >
      {children}
    </div>
  );
}

interface NarrativeCardLedeProps {
  children: React.ReactNode;
  className?: string;
}

export function NarrativeCardLede({ children, className }: NarrativeCardLedeProps) {
  return (
    <p className={cn("text-base font-semibold text-foreground", className)}>
      {children}
    </p>
  );
}
